import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ch0007',
    ecrans: ['00-2'],
    params: ['itpcleint']
});
